import "./sentry";
import 'llui/styles/table.css';
import 'llui/styles/pagination.css';
import 'llui/styles/styles.css';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { App } from "./modules/core/App/App";
import { ErrorFallback } from "./modules/core/error/ErrorFallback";
import { TombacApp } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
createRoot(document.getElementById('app')).render( /*#__PURE__*/_jsx(TombacApp, {
  defineCssVariables: true,
  theme: {
    baseUnit: 'px',
    settings: {
      modalZIndex: 10000
    }
  },
  children: /*#__PURE__*/_jsx(SentryErrorBoundary, {
    fallback: _ref => {
      let {
        error
      } = _ref;
      return /*#__PURE__*/_jsx(ErrorFallback, {
        error: error
      });
    },
    children: /*#__PURE__*/_jsx(App, {})
  })
}));